module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_vm._m(0), _vm._v(" "), _c('main', [_c('div', {
    staticClass: "notedetail"
  }, [_c('br'), _vm._v(" "), _c('el-form', {
    attrs: {
      "label-position": "right",
      "label-width": "80px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "产品名称",
      "prop": "procedureName"
    }
  }, [_c('el-input', {
    attrs: {
      "autocomplete": "off",
      "disabled": ""
    },
    model: {
      value: (this.Detail.procedureName),
      callback: function($$v) {
        _vm.$set(this.Detail, "procedureName", $$v)
      },
      expression: "this.Detail.procedureName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "品牌名称",
      "prop": "brandName"
    }
  }, [_c('el-input', {
    attrs: {
      "autocomplete": "off",
      "disabled": ""
    },
    model: {
      value: (this.Detail.brandName),
      callback: function($$v) {
        _vm.$set(this.Detail, "brandName", $$v)
      },
      expression: "this.Detail.brandName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "生产日期",
      "prop": "procedureDate"
    }
  }, [_c('el-input', {
    attrs: {
      "autocomplete": "off",
      "disabled": ""
    },
    model: {
      value: (this.Detail.procedureDate),
      callback: function($$v) {
        _vm.$set(this.Detail, "procedureDate", $$v)
      },
      expression: "this.Detail.procedureDate"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "受检单位",
      "prop": "subjectUnit"
    }
  }, [_c('el-input', {
    attrs: {
      "autocomplete": "off",
      "disabled": ""
    },
    model: {
      value: (this.Detail.subjectUnit),
      callback: function($$v) {
        _vm.$set(this.Detail, "subjectUnit", $$v)
      },
      expression: "this.Detail.subjectUnit"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "标示生产企业",
      "prop": "manufacturingEnterprise"
    }
  }, [_c('el-input', {
    attrs: {
      "autocomplete": "off",
      "disabled": ""
    },
    model: {
      value: (this.Detail.manufacturingEnterprise),
      callback: function($$v) {
        _vm.$set(this.Detail, "manufacturingEnterprise", $$v)
      },
      expression: "this.Detail.manufacturingEnterprise"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "检验报告编号",
      "prop": "reportCode"
    }
  }, [_c('el-input', {
    attrs: {
      "autocomplete": "off",
      "disabled": ""
    },
    model: {
      value: (this.Detail.reportCode),
      callback: function($$v) {
        _vm.$set(this.Detail, "reportCode", $$v)
      },
      expression: "this.Detail.reportCode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "检验结论",
      "prop": "inspectionConclusion"
    }
  }, [_c('el-input', {
    attrs: {
      "autocomplete": "off",
      "disabled": ""
    },
    model: {
      value: (this.Detail.inspectionConclusion),
      callback: function($$v) {
        _vm.$set(this.Detail, "inspectionConclusion", $$v)
      },
      expression: "this.Detail.inspectionConclusion"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "主要不合格项",
      "prop": "mainUnqualifiedItem"
    }
  }, [_c('el-input', {
    attrs: {
      "autocomplete": "off",
      "disabled": ""
    },
    model: {
      value: (this.Detail.mainUnqualifiedItem),
      callback: function($$v) {
        _vm.$set(this.Detail, "mainUnqualifiedItem", $$v)
      },
      expression: "this.Detail.mainUnqualifiedItem"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "抽查日期",
      "prop": "checkDate"
    }
  }, [_c('el-input', {
    attrs: {
      "autocomplete": "off",
      "disabled": ""
    },
    model: {
      value: (this.Detail.checkDate),
      callback: function($$v) {
        _vm.$set(this.Detail, "checkDate", $$v)
      },
      expression: "this.Detail.checkDate"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "承检机构",
      "prop": "checkMechanism"
    }
  }, [_c('el-input', {
    attrs: {
      "autocomplete": "off",
      "disabled": ""
    },
    model: {
      value: (this.Detail.checkMechanism),
      callback: function($$v) {
        _vm.$set(this.Detail, "checkMechanism", $$v)
      },
      expression: "this.Detail.checkMechanism"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否申请复检",
      "prop": "isApplyExamination"
    }
  }, [_c('el-input', {
    attrs: {
      "autocomplete": "off",
      "disabled": ""
    },
    model: {
      value: (this.Detail.isApplyExamination),
      callback: function($$v) {
        _vm.$set(this.Detail, "isApplyExamination", $$v)
      },
      expression: "this.Detail.isApplyExamination"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "复检结论",
      "prop": "recheckConclusion"
    }
  }, [_c('el-input', {
    attrs: {
      "autocomplete": "off",
      "disabled": ""
    },
    model: {
      value: (this.Detail.recheckConclusion),
      callback: function($$v) {
        _vm.$set(this.Detail, "recheckConclusion", $$v)
      },
      expression: "this.Detail.recheckConclusion"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "查处结果",
      "prop": "investigatetheResultsStr"
    }
  }, [_c('el-input', {
    attrs: {
      "autocomplete": "off",
      "disabled": ""
    },
    model: {
      value: (this.Detail.investigatetheResultsStr),
      callback: function($$v) {
        _vm.$set(this.Detail, "investigatetheResultsStr", $$v)
      },
      expression: "this.Detail.investigatetheResultsStr"
    }
  })], 1)], 1)], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "head"
  }, [_c('a', {
    staticClass: "back tl",
    attrs: {
      "href": "javascript:history.back(-1)"
    }
  }, [_c('i', {
    staticClass: "el-icon-arrow-left"
  })]), _vm._v(" "), _c('a', {
    staticClass: "font-size: 18px;text-align: center;",
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('small', {
    staticClass: "font_18 co_f"
  }, [_vm._v("监督抽查信息")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f0ef4e28","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/note/ExtractCheck.vue
// module id = 488
// module chunks = 1